import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.object.assign";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { get, merge, runIfFn, objectKeys } from "@chakra-ui/utils";
import { filterUndefined, isSubcomponent } from "./utils";
import { getComponentDefaults } from "./get-default-props";
var modifierMap = {
  sizes: "size",
  variants: "variant"
};

function checkModifiers(props, options, partId) {
  var isInOptions = options.variants != null || options.sizes != null;
  var isInProps = get(props.theme, partId) != null;
  return isInOptions || isInProps;
}

function preProcess(style, props) {
  if (!style) return;
  var out = {};

  for (var key in style) {
    if (key in props) {
      out[key] = props[key];
    } else {
      out[key] = style[key];
    }
  }

  return out;
}
/**
 * Gets the modifier styles for a component.
 * Chakra UI assumes that most component will need
 * only `variants` and `sizes` modifiers
 *
 * @param props the props object (or component props)
 * @param options the component's theming options
 * @param modifiers modifiers we support (for now, it's just variant, and size)
 */


export function getModifierStyles(props, options, modifiers) {
  var _options$themeKey$spl, _options$themeKey;

  if (modifiers === void 0) {
    modifiers = objectKeys(modifierMap);
  }
  /**
   * if no theme key was passed or no prop was passed, bail out
   */


  if (!options || !props) return undefined;
  /**
   * For nested component theme key, for example "Menu.MenuList",
   * let's split into component and sub-component.
   */

  var _ref = (_options$themeKey$spl = (_options$themeKey = options.themeKey) == null ? void 0 : _options$themeKey.split(".")) != null ? _options$themeKey$spl : [],
      _ref2 = _slicedToArray(_ref, 2),
      component = _ref2[0],
      subComponent = _ref2[1];
  /**
   * Check that the component styles exists in the theme object
   */


  var itExists = checkModifiers(props, options, "components." + component);
  if (!itExists) return undefined;
  /**
   * Get the default modifier values defined in theme
   */

  var defaultPropsInTheme = getComponentDefaults(props.theme, component);
  var styles = {};
  /**
   * Merge the props with defaultProps defined in theme
   * to provider sensible fallbacks
   */

  var computedProps = defaultPropsInTheme ? _extends({}, defaultPropsInTheme, filterUndefined(props)) : props;
  /**
   * Iterate through each modifier (mostly variants and sizes),
   * can compute the styles based on theme.
   */

  var _iterator = _createForOfIteratorHelper(modifiers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var modifier = _step.value;
      var _modifier = modifierMap[modifier];
      var value = computedProps[_modifier];
      if (!value) continue;
      /**
       * Check if the modifier is in `options`.
       *
       * We'd like users to be able style component variants
       * without putting it in the theme.
       *
       * @example
       *
       * ```jsx
       * const Button = chakra("button", {
       *   variants: {
       *     solid: {},
       *     outline: {}
       *   },
       *   sizes: {
       *     large: {},
       *     medium: {}
       *   }
       * })
       * ```
       */

      var modifierInOptions = options == null ? void 0 : options[modifier];
      var modifierStylesOrFn = modifierInOptions && runIfFn(modifierInOptions, props);
      var modifierStylesInOptions = modifierStylesOrFn == null ? void 0 : modifierStylesOrFn[value];
      /**
       * Get styles from options if it exists else, get styles from theme
       */

      var styleObjectOrFn = modifierStylesInOptions != null ? modifierStylesInOptions : get(props.theme, "components." + component + "." + modifier + "." + value);
      if (!styleObjectOrFn) continue;
      var style = runIfFn(styleObjectOrFn, computedProps);
      style = preProcess(style, computedProps);
      if (!style) continue;
      var subcomponentStyle = style[subComponent];

      var _isSubcomponent = options.themeKey && isSubcomponent(options.themeKey);

      if (_isSubcomponent && subcomponentStyle) {
        styles = merge(styles, subcomponentStyle);
      } else {
        styles = merge(styles, style);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return styles;
}